module.exports = __webpack_public_path__ + "static/media/SofiaProLight.52fa5a50.otf";